import { useEffect } from 'react';

// Icono base SimplyTeam: bocadillo + tres compañeros sobre tarjeta blanca.
// Mismo glifo que public/favicon.svg para que base y badge sean coherentes.
const ICON = `
  <rect x="8" y="8" width="496" height="496" rx="112" fill="#ffffff" stroke="#e2e8f0" stroke-width="2"/>
  <path d="M132 72 H380 a36 36 0 0 1 36 36 V196 a36 36 0 0 1 -36 36 H292 L262 270 L232 232 H132 a36 36 0 0 1 -36 -36 V108 a36 36 0 0 1 36 -36 Z" fill="none" stroke="#2563eb" stroke-width="22" stroke-linejoin="round"/>
  <circle cx="150" cy="340" r="40" fill="#16a34a"/>
  <path d="M92 455 L92 408 Q92 372 150 372 Q208 372 208 408 L208 455 Z" fill="#16a34a"/>
  <circle cx="362" cy="340" r="40" fill="#7c3aed"/>
  <path d="M304 455 L304 408 Q304 372 362 372 Q420 372 420 408 L420 455 Z" fill="#7c3aed"/>
  <circle cx="256" cy="322" r="52" fill="#2563eb"/>
  <path d="M180 470 L180 408 Q180 360 256 360 Q332 360 332 408 L332 470 Z" fill="#2563eb"/>
`;

// Punto rojo arriba a la derecha cuando hay actividad sin leer.
const BADGE = `<circle cx="404" cy="108" r="96" fill="#ff0000" stroke="#ffffff" stroke-width="22"/>`;

function buildFavicon(withBadge: boolean): string {
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">${ICON}${withBadge ? BADGE : ''}</svg>`;
  return `data:image/svg+xml,${encodeURIComponent(svg)}`;
}

const BASE_TITLE = 'SimplyTeam';

/**
 * Mantiene el favicon y el título de la pestaña sincronizados con el número
 * de hilos con actividad sin leer: añade un punto rojo al icono y un
 * contador "(n)" delante del título cuando unreadCount > 0.
 */
export function useFaviconBadge(unreadCount: number): void {
  useEffect(() => {
    let link = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    link.type = 'image/svg+xml';
    link.href = buildFavicon(unreadCount > 0);

    document.title = unreadCount > 0
      ? `(${unreadCount > 99 ? '99+' : unreadCount}) ${BASE_TITLE}`
      : BASE_TITLE;
  }, [unreadCount]);
}
